// -------------------------------
// WORK FROM HOME INTERFACES

import dayjs from "dayjs";

// -------------------------------
export interface PendingWorkFromHome {
    FromDate?: string;
    ToDate?: string;
    Days?: number;
    Description?: string;
}

export interface PendingDeleteWorkFromHome {
    awaitingDate?: boolean;
}
export const startCreateWorkFromHomeFlow = (
    setPending: (data: PendingWorkFromHome | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    setPending({});
    pushAIChat("From which date would you like to work from home?");
    speak("From which date would you like to work from home?");
};
export const processPendingWorkFromHome = (
    text: string,
    pending: PendingWorkFromHome,
    setPending: (data: PendingWorkFromHome | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {

    // 1️⃣ FROM DATE
    if (!pending.FromDate) {
        setPending({ ...pending, FromDate: text });
        pushAIChat("Till which date?");
        speak("Till which date?");
        return;
    }

    // 2️⃣ TO DATE → calculate days
    if (!pending.ToDate) {
        const from = dayjs(pending.FromDate);
        const to = dayjs(text);

        if (to.isBefore(from)) {
            pushAIChat("To date cannot be before from date. Please re-enter.");
            speak("To date cannot be before from date.");
            return;
        }

        const days = to.diff(from, "day") + 1;

        setPending({
            ...pending,
            ToDate: text,
            Days: days,
        });

        pushAIChat(`That will be ${days} day(s). Please provide a description.`);
        speak(`That will be ${days} days. Please provide a description.`);
        return;
    }

    // 3️⃣ DESCRIPTION → FINAL
    if (!pending.Description) {
        const finalData = {
            ...pending,
            Description: text,
        };

        pushAIChat("Submitting work from home request...");
        speak("Submitting work from home request.");

        window.dispatchEvent(
            new CustomEvent("ai-create-workfromhome", {
                detail: finalData
            })
        );

        setPending(null);
    }
};
export const startDeleteWorkFromHomeFlow = (
    setPendingDelete: (data: PendingDeleteWorkFromHome | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    setPendingDelete({ awaitingDate: true });
    pushAIChat("Please tell me the from date of the work from home request to delete.");
    speak("Please tell me the from date.");
};
export const processPendingDeleteWorkFromHome = (
    text: string,
    pending: PendingDeleteWorkFromHome,
    setPendingDelete: (data: PendingDeleteWorkFromHome | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    if (!pending.awaitingDate) return;

    const date = text.trim();
    if (!date) return;

    pushAIChat(`Deleting work from home request starting ${date}...`);
    speak(`Deleting work from home request.`);

    window.dispatchEvent(
        new CustomEvent("ai-delete-workfromhome", {
            detail: { FromDate: date }
        })
    );

    setPendingDelete(null);
};
